import { Component, OnInit, signal } from "@angular/core";
import { CardModule } from "primeng/card";
import { TagModule } from "primeng/tag";
import { AvatarModule } from "primeng/avatar";
import { DividerModule } from "primeng/divider";
import { ChipModule } from "primeng/chip";
import { ProgressBarModule } from "primeng/progressbar";
import { ButtonModule } from "primeng/button";
import {
  SessionData,
  SessionService,
} from "../../../Utils/_services/session/session.service";
import { finalize } from "rxjs";
import { AdminService } from "../../../Utils/_services/admin/admin/admin.service";
import { AccountSettingComponent } from "../../admin/settings/account-setting/account-setting.component";


@Component({
  selector: "app-profile-detail",
  standalone: true,
  imports: [
    CardModule,
    TagModule,
    AvatarModule,
    DividerModule,
    ChipModule,
    ProgressBarModule,
    ButtonModule,
    AccountSettingComponent
  ],
  templateUrl: "./profile-detail.component.html",
  styleUrl: "./profile-detail.component.css",
})
export class ProfileDetailComponent implements OnInit {

  admin = signal<SessionData | undefined>(undefined);
 profilePhotoUrl: string | null = null;
  constructor(private sessionService: SessionService,
     private adminService: AdminService
  ) {}

  ngOnInit(): void {
    this.sessionService.sessionData$.subscribe(data => {
      if (data) {
        this.admin.set(data);

        this.getUserById(data.user._id);
      }
    });
  }
   getUserById(id: string) {
    if (!id) return;
    this.adminService.getUserById(id).pipe(
      finalize(() => {})
    ).subscribe({
      next: (res) => {
        const primaryPhoto = res.data.profilePhotos?.find((p: any) => p.isPrimary);
        this.profilePhotoUrl = primaryPhoto?.signedUrl ?? null;
      },
      error: (err) => console.error('Error fetching user:', err)
    });
  }

get email(): string {
  const adminData = this.admin();
  return adminData?.user?.email || '';
}
  // fullName = computed(() => {
  //   const adminData = this.admin();
  //   return adminData ? `${adminData.user.firstName}` : "";
  // });

  getInitials(): string {
    const adminData = this.admin();
    if (!adminData) return "A";
    return `${adminData.user.firstName[0]}`.toUpperCase();
  }

  getRoleDisplay(role: string): string {
    const roleMap: Record<string, string> = {
      super_admin: "Super Admin",
      admin: "Admin",
      moderator: "Moderator",
      user: "User",
    };
    return roleMap[role] || role;
  }

  getRoleSeverity(role: string): string {
    const severityMap: Record<string, string> = {
      super_admin: "p-tag-danger",
      admin: "p-tag-warning",
      moderator: "p-tag-info",
      user: "p-tag-secondary",
    };

    return severityMap[role] || "p-tag-secondary";
  }

  // getRoleSeverity(
  //   role: string
  // ): "success" | "secondary" | "info" | "warning" | "danger" | "contrast" {
  //   const severityMap: Record<
  //     string,
  //     "success" | "secondary" | "info" | "warning" | "danger" | "contrast"
  //   > = {
  //     super_admin: "danger",
  //     admin: "warning",
  //     moderator: "info",
  //     user: "secondary",
  //   };
  //   return severityMap[role] || "secondary";
  // }

  getRoleIcon(role: string): string {
    const iconMap: Record<string, string> = {
      super_admin: "pi pi-crown",
      admin: "pi pi-shield",
      moderator: "pi pi-user-edit",
      user: "pi pi-user",
    };
    return iconMap[role] || "pi pi-user";
  }

  // getProgressPercentage(): number {
  //   const adminData = this.admin();
  //   if (!adminData) return 0;
  //   return (adminData.user.registrationStep / 4) * 100;
  // }

  getPermissions(role: string): Array<{ name: string; granted: boolean }> {
    const allPermissions = [
      { name: "User Management", granted: false },
      { name: "Content Moderation", granted: false },
      { name: "System Settings", granted: false },
      { name: "Reports & Analytics", granted: false },
      { name: "Partner Management", granted: false },
      { name: "Financial Operations", granted: false },
    ];

    if (role === "super_admin") {
      return allPermissions.map(p => ({ ...p, granted: true }));
    } else if (role === "admin") {
      return allPermissions.map((p, i) => ({ ...p, granted: i < 4 }));
    } else if (role === "moderator") {
      return allPermissions.map((p, i) => ({ ...p, granted: i < 2 }));
    }

    return allPermissions;
  }
}
